import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { popularComics } from '@/mocks/comics';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const hot = ['玄幻', '武侠', '都市', '热血', '恋爱', '科幻'];

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/guoman?q=${encodeURIComponent(q)}` : '/guoman');
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100 via-background-50 to-secondary-100" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-accent-200/50 blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-primary-200/40 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-sparkling-2-line text-accent-500"></i>
            国漫 · 日漫分类大全
          </span>
          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-5xl">
            想看什么漫画，
            <br />
            <span className="text-primary-500">点开分类就有</span>
          </h1>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-foreground-600">
            虫虫漫画按题材、类型整理国漫与日漫，热门连载与经典作品一站收录。选一个分类，轻松逛遍你喜欢的作品。
          </p>

          <form onSubmit={submitSearch} className="mt-7 flex items-center gap-2 rounded-full border border-background-200 bg-background-50 p-1.5 shadow-soft max-w-xl">
            <i className="ri-search-line pl-3 text-lg text-foreground-400" aria-hidden="true"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="搜索漫画标题或题材，例如：玄幻、武侠…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
            <button type="submit" className="flex h-11 shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-primary-600 transition-colors">
              去逛逛
            </button>
          </form>

          <div className="mt-4 flex flex-wrap items-center gap-2 text-sm text-foreground-500">
            <span className="whitespace-nowrap">大家都在看：</span>
            {hot.map((k) => (
              <button
                key={k}
                type="button"
                onClick={() => navigate(`/guoman?q=${encodeURIComponent(k)}`)}
                className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors"
              >
                {k}
              </button>
            ))}
          </div>
        </div>

        <div className="relative hidden lg:block h-[420px]">
          <div className="absolute left-0 top-6 w-44 animate-floaty rotate-[-6deg]">
            <HeroCover idx={0} />
          </div>
          <div className="absolute left-40 top-0 w-52 z-10 animate-floatySlow rotate-[3deg]">
            <HeroCover idx={1} />
          </div>
          <div className="absolute right-0 top-16 w-44 animate-floaty rotate-[7deg]">
            <HeroCover idx={2} />
          </div>
          <div className="absolute -right-2 bottom-2 flex items-center gap-2 rounded-full bg-foreground-950 px-4 py-2 text-sm text-background-50 shadow-lift">
            <i className="ri-fire-fill text-accent-400"></i>
            每日更新 · 持续收录
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroCover({ idx }: { idx: number }) {
  const comic = popularComics[idx];
  return (
    <div className="overflow-hidden rounded-2xl border-4 border-background-50 shadow-lift">
      <img src={comic.cover} alt={`${comic.title}热门连载封面`} className="h-full w-full object-cover" />
    </div>
  );
}